import { HTTP } from '../core/http';

export const changeTicket = (Data) => {
    const {
        social_id,
        correo,
        telefono,
        nombre,
        endFunction,
        errorFunction
    } = Data;

    HTTP({
        method: 'POST',
        data: {
            social_id,
            correo,
            telefono,
            nombre
        },
        url: 'https://ha-back.demasys.net/api/pinata/change_boleto'
    }).then((response) => {
        const responseData = response && response.data && response.data.status ? true : false;
        if(responseData) {
            endFunction({error: false});
        } else {
            errorFunction('Error de servidor...');
        }
    }).catch((error) => {
        let messageError = 'Error de servidor...';
        if(error && error.response && error.response.data && error.response.data.message) {
            messageError = error.response.data.message;
        }
        errorFunction(messageError);
    });
};

export const changeKit = (Data) => {
    const {
        idPrize,
        social_id,
        nombre,
        correo,
        celular,
        calle,
        codigo_postal,
        ciudad,
        colonia,
        endFunction,
        errorFunction
    } = Data;

    HTTP({
        method: 'POST',
        data: {
            social_id,
            nombre,
            correo,
            celular,
            calle,
            codigo_postal,
            ciudad,
            colonia,
            premio_id: idPrize
        },
        url: 'https://ha-back.demasys.net/api/pinata/formulario'
    }).then((response) => {
        const responseData = response && response.data && response.data.status ? true : false;
        if(responseData) {
            endFunction({error: false});
        } else {
            errorFunction('Error de servidor...');
        }
    }).catch((error) => {
        let messageError = 'Error de servidor...';
        if(error && error.response && error.response.data && error.response.data.message) {
            messageError = error.response.data.message;
        }
        errorFunction(messageError);
    });
};
